module.exports = __webpack_public_path__ + "static/media/close.67f01769.svg";